import { Component } from '@angular/core';

@Component({
  selector: 'app-message-two',
  templateUrl: './message-two.component.html',
  styleUrls: ['./message-two.component.scss']
})
export class MessageTwoComponent {

}
